import type { ExplainStep } from "@aybuben/core/lesson.ts";

import { useCourse } from "../../content/context.tsx";
import { useStrings } from "../../i18n/index.tsx";
import { COL } from "../../theme.ts";
import { SoundButton } from "../../ui/sound.tsx";
import { FaceView, StepHead } from "../kit.tsx";
import { registerView, type ExerciseViewProps } from "../view-registry.ts";

function ExplainView({ step }: ExerciseViewProps<ExplainStep, string>) {
	const t = useStrings();
	const course = useCourse();
	const hasLead = step.rows.some((r) => r.lead !== null);
	return (
		<div>
			<StepHead title={t("lesson.explainTitle")} retry={false} retryNote="" />
			<p className="mt-3 leading-relaxed">{step.rule}</p>

			<div className="mt-5 overflow-hidden rounded-2xl" style={{ border: `2px solid ${COL.line}` }}>
				{step.rows.map((r, i) => {
					const audio = course.itemById(r.itemId).audio;
					return (
						<div
							key={r.itemId}
							className="flex items-center gap-3 px-3 py-2"
							style={{ background: i % 2 ? COL.tint : COL.card }}
						>
							{hasLead && (
								<div className="w-20 shrink-0" style={{ color: COL.mute }}>
									{r.lead && <FaceView face={r.lead} size={22} />}
								</div>
							)}
							<div className="w-20 shrink-0">
								<FaceView face={r.form} size={24} />
							</div>
							<div className="text-sm" style={{ color: COL.mute }}>
								{r.gloss}
							</div>
							{audio && <SoundButton asset={audio} className="ml-auto" />}
						</div>
					);
				})}
			</div>

			<p className="mt-5 leading-relaxed">{step.order}</p>
			<p
				className="mt-3 rounded-2xl p-3 text-sm leading-relaxed"
				style={{ background: COL.apricotSoft, color: COL.ink }}
			>
				{step.watch}
			</p>
		</div>
	);
}

// No Feedback: an explain card is never graded, so the shell never shows a
// panel for it — the same contract intro/view.tsx has.
registerView<ExplainStep, string>("explain", { View: ExplainView, action: "continue" });
